module.exports = __webpack_public_path__ + "img/18 Degrees Festival Shillong-2014.e7826a1b.jpg";